import { axiosGet, axiosPost } from '@/api/AxiosApi';

const apiUrl = process.env.REACT_APP_API_POINT_URL;
// 내가 보유한 총 포인트 잔액
export const total = async () => {
  const payload = {
    apiUrl,
    path: '/v1/point/total',
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

export type usageDetailsProps = {
  list_size?: string;
  page_num?: string;
  search_dt_st?: string;
  search_dt_ed?: string;
  type?: 'charge' | 'refund' | 'transfer';
  order?: 'ASC' | 'asc' | 'DESC' | 'desc';
};
// 이용내역
export const usageDetails = async (aData: usageDetailsProps) => {
  const payload = {
    apiUrl,
    path: '/v1/point/charge/list',
    body: aData,
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

// 충전가능금액
export const chargeAble = async () => {
  const payload = {
    apiUrl,
    path: '/v1/point/chargeable',
  };
  const { data: re } = await axiosGet(payload);
  return re;
};

// 바코드 가져오기
export const barCode = async () => {
  const payload = {
    apiUrl,
    path: '/v1/point/pay/barcode',
  };
  const { data: re } = await axiosGet(payload);
  return re;
};
